import { createClient } from "@supabase/supabase-js";

// Fail closed, loudly, at startup. A console that silently pointed at the
// wrong project is this product's founding hazard (ADR-06, ADR-34): the
// candidate-database MCP mixup happened because a connection went where nobody
// checked. The URL names its project ref, so the thrown message makes the
// target visible the same way tools/db.py announces it.
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

if (!url || !key) {
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are not set. " +
      "Development runs against a preview branch: copy .env.example to " +
      ".env.local and fill it in. Never point development at production.",
  );
}

// ADR-06: this ref must never appear here.
if (url.includes("rbdhhwhgycaevuqbtqtd")) {
  throw new Error(
    "The configured Supabase project is the candidate database. ADR-06 " +
      "forbids this product touching it. Fix the env file before anything runs.",
  );
}

// detectSessionInUrl: false — the auth client never reads a session out of
// the URL. The invite callback is a code exchange (/auth/accept calls
// verifyOtp with a token_hash; architect ruling Q3), and the implicit flow,
// whose session sat in the URL fragment, is removed rather than kept as a
// fallback: a fragment carrying a token is refused by the route, and this
// setting makes sure the library does not consume it first.
export const supabase = createClient(url, key, { auth: { detectSessionInUrl: false } });

/** The project this build is talking to, for display in the shell footer. */
export const projectRef = new URL(url).hostname.split(".")[0] ?? "unknown";
